module.exports = __webpack_public_path__ + "assets/img/1370-um.svg";